import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MessageCircle } from "lucide-react";
import { SITE, whatsappLink } from "@/lib/site";
import { useShop } from "@/context/ShopContext";

export default function Footer() {
  const { openEnquiry } = useShop();
  return (
    <footer className="border-t border-gold/20 bg-bg2" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16 py-16 lg:py-20">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo.jpg" alt="Sashti Jewels" className="h-12 w-12 rounded-full object-cover border border-gold/40" />
              <span className="leading-none">
                <span className="block font-brand text-2xl font-bold text-ink" style={{ letterSpacing: "0.02em" }}>Sashti</span>
                <span className="block font-cinzel text-[10px] font-semibold uppercase text-gold" style={{ letterSpacing: "0.42em" }}>Jewels</span>
              </span>
            </div>
            <p className="mt-5 font-display text-lg italic text-ink2 max-w-xs">
              {SITE.tagline}
            </p>
            <div className="mt-5 flex gap-3">
              <span className="chip">Antique Gold Plating</span>
              <span className="chip">Skin-Safe Finish</span>
            </div>
          </div>

          <div>
            <p className="overline-tag">Explore</p>
            <ul className="mt-5 space-y-3 text-sm text-ink2">
              <li><Link to="/shop" className="hover:text-gold transition-colors">All Jewels</Link></li>
              <li><Link to="/lookbook" className="hover:text-gold transition-colors">Lookbook</Link></li>
              <li><Link to="/shop?category=Temple" className="hover:text-gold transition-colors">Temple Heritage</Link></li>
              <li><Link to="/shop?category=Bridal" className="hover:text-gold transition-colors">Bridal Trousseau</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors">Concierge &amp; Care</Link></li>
            </ul>
          </div>

          <div>
            <p className="overline-tag">Reach Us</p>
            <ul className="mt-5 space-y-3 text-sm text-ink2">
              <li>
                <a href={whatsappLink("Hello Sashti Jewels, I'd like to know more about your collections.")} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-direct-button"
                   className="flex items-center gap-2 hover:text-gold transition-colors">
                  <MessageCircle size={15} className="text-gold" /> WhatsApp — {SITE.whatsappDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-gold transition-colors">
                  <Mail size={15} className="text-gold" /> {SITE.email}
                </a>
              </li>
              <li>
                <button onClick={() => openEnquiry()} className="group flex items-center gap-1.5 text-gold font-cinzel text-[11px] uppercase" style={{ letterSpacing: "0.22em" }} data-testid="footer-enquiry-button">
                  Book Private Concierge <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-hr mt-14 mb-8" />
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-[11px] font-cinzel uppercase text-ink2" style={{ letterSpacing: "0.18em" }} data-testid="footer-policy-links">
            <Link to="/policies/refund-return" className="hover:text-gold transition-colors">Refund &amp; Return Policy</Link>
            <Link to="/policies/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link>
            <Link to="/policies/terms" className="hover:text-gold transition-colors">Terms of Service</Link>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-ink3 font-mono w-full">
            <span>© {new Date().getFullYear()} {SITE.domain} — All rights reserved</span>
            <span>Handcrafted in South India</span>
            <Link to="/admin" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
